import styled from 'styled-components/macro';
import { BREAKPOINTS } from 'utils/styles';

export const SuccessRequestPage = styled.div`
  width: 450px;
  height: 290px;
  margin: auto;
  text-align: center;
  margin-top: 40px;

  img {
    margin-bottom: 50px;
  }
  @media ${BREAKPOINTS.md} {
    width: 250px;
  }
`;

export const StyledQuestionsContainer = styled.div`
  margin-top: 56px;
`;

export const StyledImageContainer = styled.img`
  margin-top: 40px;
`;

export const StyledWrapperText = styled.p`
  margin-top: 40px;
`;
